// frontend/src/screens/LoginScreen.jsx
import { useLocation, useNavigate } from 'react-router-dom';

// material-ui

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLoginMutation } from '../slices/usersApiSlice';
import { setCredentials } from '../slices/authSlice';

// ================================|| AUTH3 - LOGIN ||================================ //

const LoginScreen = () => {
  const [message, setMessage] = useState('');
  const [loginInput, setLoginInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, { isLoading, isError, error }] = useLoginMutation();
  const { userInfo } = useSelector((state) => state.auth);

  //смотрим в адресной строке не пришел ли посетитель сюда
  //при попытке попасть на другую страницу, где требуется быть авторизованным
  const { search } = useLocation(); //вытащили этот фрагмент "?redirect=/shipping"
  // hash: ""
  // key: "gyb0pjcd"
  // pathname: "/login"
  // search: "?redirect=/shipping"
  // state: null
  const sp = new URLSearchParams(search);
  const redirect = sp.get('redirect') || '/'; //получили путь, куда направлялся посетитель прежде чем попал на Авторизацию или на главную

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      //If you need to access the error or success payload immediately after a mutation, you can chain .unwrap()
      const res = await login({
        login: loginInput,
        password: passwordInput,
      }).unwrap(); //to usersApiSlice = apiSlice.injectEndpoints({login:
      dispatch(setCredentials({ ...res }));
      navigate(redirect);
    } catch (error) {
      //console.log(error);
      if (error.status === 'PARSING_ERROR') {
        setMessage('Сервер недоступен');
      } else {
        setMessage(error?.data?.message || error.error);
      }
    }
  };

  useEffect(() => {
    //если userInfo заполнено, значит пользователь авторизован
    if (userInfo) {
      //перенаправляем его туда, куда он направлялся
      navigate(redirect);
    }
  }, [userInfo, redirect, navigate]);

  const vertical = 'top';
  const horizontal = 'center';

  // if (isError) {
  //   setMessage(isError?.data?.message || isError?.error || isError?.message);
  //   return <></>;
  // }

  // if (isError) {
  //   if (isError?.status === 'PARSING_ERROR') {
  //     setMessage('Сервер недоступен');
  //   } else {
  //     setMessage(isError?.data?.message || isError?.error || isError?.message);
  //   }
  // }

  return (
    <Dialog fullScreen open={true}>
      {
        <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
          Добро пожаловать
        </DialogTitle>
      }
      {isLoading ? (
        <CircularProgress />
      ) : (
        <DialogContent dividers>
          <Box
            sx={{
              maxWidth: 550,
              px: 3,
              py: '20px',
              width: '100%',
            }}
          >
            {isError && (
              <Alert variant='error'>
                {error?.data?.message || error?.error || error?.message}
              </Alert>
            )}
            <div>
              <Stack spacing={1} sx={{ mb: 3 }}>
                <Typography variant='h4'>Войти</Typography>
                {/* <Typography color='text.secondary' variant='body2'>
                Вы здесь впервые? &nbsp;
                <Link to='/register' underline='hover' variant='subtitle2'>
                  Создать аккаунт
                </Link>
              </Typography> */}
              </Stack>
              <form noValidate>
                <Stack spacing={3}>
                  <TextField
                    id='username'
                    //ref={userRef}
                    autoComplete='off'
                    onChange={(e) => setLoginInput(e.target.value)}
                    value={loginInput}
                    error={false}
                    fullWidth
                    //helperText={formik.touched.email && formik.errors.email}
                    label='Логин'
                    name='login'
                    //onBlur={formik.handleBlur}
                    //onChange={formik.handleChange}
                    type='text'
                    //value={formik.values.email}
                  />
                  <TextField
                    id='password'
                    onChange={(e) => setPasswordInput(e.target.value)}
                    value={passwordInput}
                    //required
                    error={false}
                    fullWidth
                    //helperText={'не ме'}
                    //formik.touched.password && formik.errors.password
                    //}
                    label='Пароль'
                    name='password'
                    //onBlur={formik.handleBlur}
                    //onChange={formik.handleChange}
                    type='password'
                    //value={formik.values.password}
                  />
                </Stack>
                {/* <FormHelperText sx={{ mt: 1 }}>
                  Optionally you can skip.
                </FormHelperText> */}
                {/* {formik.errors.submit && ( */}
                <Typography
                  //ref={errRef}
                  color='error'
                  sx={{ mt: 3 }}
                  variant='body2'
                >
                  {/*errMsg*/}
                </Typography>

                <Button
                  onClick={submitHandler}
                  fullWidth
                  size='large'
                  sx={{ mt: 3 }}
                  type='submit'
                  variant='contained'
                >
                  Продолжить
                </Button>
                {/* <Button
                  fullWidth
                  size='large'
                  sx={{ mt: 3 }}
                  //onClick={handleSkip}
                >
                  Skip authentication
                </Button> */}
                {/* <Alert color='primary' severity='info' sx={{ mt: 3 }}>
                  <div>
                    Для ознакомления используйте <b>da@da.da</b> and пароль{' '}
                    <b>da!123</b>
                  </div>
                </Alert> */}
              </form>
            </div>
          </Box>
        </DialogContent>
      )}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={message !== ''}
        onClose={() => setMessage('')}
        message={message}
        key={'vertical + horizontal'}
      />
    </Dialog>
  );
};

export default LoginScreen;
